import { createFileRoute } from '@tanstack/react-router'
import { DeploySettingsConfig } from '~/features/webchat/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings')({
  component: Component,
})

function Component() {
  const { botId, workspaceId } = Route.useParams()

  return <DeploySettingsConfig botId={botId} workspaceId={workspaceId} />
}
